import React, { FC } from 'react';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import Button, { ButtonProps } from 'vibo-ui/Button';

import { useModal } from 'vibo-ui/Modal';
import { onError } from 'graphql/helpers';
import { useViboTheme } from 'components/context/ViboThemeContext';
import { appLightColor } from 'components/context/ViboThemeContext/constants';

import { UPDATE_UPLICATION_COLOR } from 'graphql/mutations/user';

import { Modals } from 'types/enums';
import { PickBrandingColorModalProps } from 'components/modals/PickBrandingColorModal/interfaces';

const PickBrandingColorButton: FC<ButtonProps> = ({ ...rest }) => {
  const { t } = useTranslation();

  const { resetToAppColor } = useViboTheme();
  const { openModal } = useModal();

  const appColor = appLightColor();

  const [updateApplicationColor] = useMutation(UPDATE_UPLICATION_COLOR, {
    onCompleted: () => resetToAppColor(),
    refetchQueries: ['getMe'],
    onError,
  });
  const openPickBrandingColorModal = () =>
    openModal<PickBrandingColorModalProps>({
      key: Modals.pickBrandingColor,
      props: {
        defaultColor: appColor,
        handleUpdateColor: applicationColor =>
          updateApplicationColor({
            variables: {
              payload: {
                applicationColor,
              },
            },
          }),
      },
    });

  return (
    <Button
      onClick={openPickBrandingColorModal}
      displayType="link"
      shape="round"
      size="lg"
      {...rest}
    >
      {t('djBrandColor')}
    </Button>
  );
};

export default PickBrandingColorButton;
